module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-detailTask"
  }, [_c('div', {
    staticClass: "detail-head"
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": require("assets/image/back-close.svg")
    },
    on: {
      "click": _vm.back
    }
  })]), _vm._v(" "), _c('taskDetail', {
    staticClass: "detail-main",
    on: {
      "openDoc": _vm.openDocument
    }
  }), _vm._v(" "), _c('downDocument', {
    attrs: {
      "flag": _vm.docTpl_flag
    },
    on: {
      "close": _vm.closeDocument
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-341026af!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/task/page-detailTask.vue
// module id = 723
// module chunks = 1